import * as Stitches from '@stitches/react';
import { styled } from '@gbm-tech/styles';

const PageItemContainerHover: Stitches.CSS = {
  borderBottom: '1px solid $gray200',

  '.icon, span, .arrow': {
    color: '#404a59',
  },

  '.arrow': {
    borderColor: '$blue200',
  },
};

const PageItemContainerLG: Stitches.CSS = {
  gap: '1.2rem',
};

const PageItemContainerXL: Stitches.CSS = {
  gap: '1.4rem',
};

const PageItemContainerXXL: Stitches.CSS = {
  gap: '1.6rem',
};

const PageItemContainerXXXL: Stitches.CSS = {
  span: {
    fontSize: '1.8rem',
    lineHeight: '3.2rem',
  },
};

export const PageItemContainer = styled('a', {
  padding: '1.2rem 1.6rem 1.2rem 2.2rem',

  display: 'flex',
  alignItems: 'center',
  gap: '1rem',

  border: 'none',
  outline: 'none',
  borderBottom: '1.5px solid $blue50',
  backgroundColor: 'white',

  textDecoration: 'none',

  cursor: 'pointer',
  transition: 'all ease-in-out 0.4s',

  '> span': {
    flex: 1,

    textAlign: 'left',
    fontSize: '1.4rem',
    lineHeight: '2.4rem',
    fontWeight: 500,

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    color: '$gray500',
  },

  '&:hover': { ...PageItemContainerHover },

  '@lg': { ...PageItemContainerLG },

  '@xl': { ...PageItemContainerXL },

  '@xxl': { ...PageItemContainerXXL },

  '@xxxl': { ...PageItemContainerXXXL },
});
